
<template>
  <div
    ref="annotationWrapper"
    class="annotation-wrapper"
    @mouseenter="onMouseEnter"
    @mousemove="onMouseMove"
    @mouseleave="onMouseLeave"
    @click.self="onMouseClick"
  >
    <div
      class="annotations"
    >
      <div
        v-if="hasCurrentAnnotation"
        :style="getMarkerLoaction(currentAnnotation)"
        id="current-annotation"
        class="annotation transform"
      />
      <div
        v-for="(a, index) in annotations"
        :key="index"
        :style="getMarkerLoaction(a)"
        :id="`annotation-${index}`"
        class="annotation faded"
      />
    </div>
    <div
      v-if="allow && showTooltip"
      class="tooltip show"
      role="tooltip"
      tabindex="-1"
      x-placement="bottom"
      style="position: fixed; will-change: transform; top: 0px; left: 0px;"
      :style="tooltipStyle"
    >
      <div class="tooltip-inner">
        <div>Click to add annotation</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentAnnotations',
  props: {
    size: {
      type: Object,
      default: () => {},
    },
    allow: {
      type: Boolean,
      default: false,
    },
    annotations: {
      type: Array,
      default: () => [],
    },
    currentAnnotation: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      tooltipStyle: {},
      showTooltip: false,
    };
  },

  computed: {
    width() {
      return this.size.width;
    },

    height() {
      return this.size.height;
    },
    hasCurrentAnnotation() {
      return (Object.keys(this.currentAnnotation).length !== 0);
    },
  },

  methods: {
    onMouseEnter() {
      this.showTooltip = true;
    },

    onMouseMove(event) {
      const { clientX, clientY } = event;
      this.tooltipStyle = {
        top: `${clientY + 10}px`,
        left: `${clientX + 10}px`,
      };
    },

    onMouseLeave() {
      this.showTooltip = false;
    },

    onMouseClick(event) {
      const location = { x: event.offsetX, y: event.offsetY };
      // this.currentAnnotation = location;
      this.$emit('setCurrentAnnotation', location);
    },
    getMarkerLoaction(location) {
      return `left: ${location.x - 8}px; top: ${location.y - 8}px;`;
    },
  },

  watch: {

  },

  mounted() {
  },
};
</script>

<style lang="scss">
// .template {
//   position: absolute;
//   width: 100%;
//   height: 100%;
// }

.annotation-wrapper {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  cursor: copy;
}

.annotation {
  background: #3499ad;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  position: absolute;
  z-index: 12;
  border: 2px solid #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-shadow: 1px 1px 4px rgba(0,0,0,.6);
  box-shadow: 1px 1px 4px rgba(0,0,0,.6);
}
.annotation.transform {
  -webkit-animation: grow .3s;
  animation: grow .3s;
}
.faded {
  opacity: 0.75;
}
@-webkit-keyframes grow {
    0% {
        -webkit-transform:scale(0);
    }
    70% {
        -webkit-transform:scale(1.4);
    }
    100% {
        -webkit-transform:scale(1);
    }
}
@-moz-keyframes grow {
    0% {
        -webkit-transform:scale(0);
    }
    70% {
        -webkit-transform:scale(1.4);
    }
    100% {
        -webkit-transform:scale(1);
    }
}
@keyframes grow {
    0% {
        -webkit-transform:scale(0);
    }
    70% {
        -webkit-transform:scale(1.4);
    }
    100% {
        -webkit-transform:scale(1);
    }
}
</style>
